exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-inco-termini-js": () => import("./../../../src/pages/inco_termini.js" /* webpackChunkName: "component---src-pages-inco-termini-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-termini-js": () => import("./../../../src/pages/termini.js" /* webpackChunkName: "component---src-pages-termini-js" */),
  "component---src-pages-zakoni-js": () => import("./../../../src/pages/zakoni.js" /* webpackChunkName: "component---src-pages-zakoni-js" */)
}

